
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/AuthService";
import * as Actions from "../../reducers/actions";
import {
  Redirect
} from "react-router-dom";
import BLOCK3 from "../block/block-3";
import BLOCK6 from "../block/block-6";
import BLOCK7 from "../block/block-7";

import ChartistGraph from "react-chartist";
import { Grid, Row, Col } from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { StatsCard } from "components/StatsCard/StatsCard.jsx";
import { Tasks } from "components/Tasks/Tasks.jsx";

import {
  dataPie,
  legendPie,
  dataSales,
  optionsSales,
  responsiveSales,
  legendSales,
  dataBar,
  optionsBar,
  responsiveBar,
  legendBar
} from "variables/Variables.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

class XMain extends Component {
  constructor(props) {
    super(props);
    this.state = {  };
    this.logout = this.logout.bind(this);
  }
  logout(){
    console.log('logout')
    this.props.dispatch(Actions.setToken(false));
  }
 
  render() {
    return <div className="App content">
        {!this.props.token ? <Redirect to="/" /> : <div />}
        <div id="wrapper">
          <div id="body" style={{ visibility: "visible", padding: 8 , background:'#F7F7F8'}}>
            <Grid fluid>
              <Row>
                <Col lg={3} sm={6}>
                  <Card title=" ยินดีต้อนรับ" category={this.props.user.ACCOUNT_NAME} 
                      legend={<div className="legend">
                        <Button bsStyle="info" pullRight fill onClick={() => {
                          this.logout()
                        
                        }}>
                          ออกจากระบบ
                        </Button>
                      </div>} 
                     content={<div className="">
                      </div>} />
                </Col>
                <Col lg={9} sm={6}>
                    <BLOCK3 />
                </Col>
              <Col lg={3} sm={6}>
              </Col>
              <Col lg={9} sm={6}>
                <BLOCK7 />
              </Col>
              </Row>
            </Grid>

            {/* <GridContainer>
              <GridItem xs={12} sm={6} md={3}>
                <Card>
                  <CardHeader color="warning">
                    <h4 className={"Dashboard-cardTitleWhite-851"}>
                      ยินดีต้อนรับ
                    </h4>
                    <p className={"Dashboard-cardCategoryWhite-849"}>
                      {this.props.user.ACCOUNT_NAME}
                    </p>
                  </CardHeader>
                  <CardBody profile>
                    <Button onclick={() => this.logout()} color="">
                      ออกจากระบบ
                    </Button>
                  </CardBody>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={6} md={9}>
              </GridItem>
              <GridItem xs={12} sm={6} md={3} />
              <GridItem xs={12} sm={6} md={9}>
                <BLOCK7 pltbldid={this.props.user.PLT_BLD_ID} />
              </GridItem>
            </GridContainer> */}
          </div>
        </div>
      </div>;
  }
}
function mapStateToProps(state) {
  return { token: state.default.token, user: state.default.user };
}

export default connect(mapStateToProps)(XMain);
// export default Singin;


// WEBPACK FOOTER //
// ./src/view/main/main.js